<template>
  <VuePerfectScrollbar
    ref="perfectScollbar"
    :settings="settings"
    class="scroll-area"
  >
    <div
      ref="sideMenu"
      :class="{
        'side-menu': true,
        'side-menu--inactive': !isMounted
      }"
    >
      <ul class="side-menu__list">
        <li
          v-for="item in menuItems"
          :key="item.key"
          :class="{
            'side-menu__item': true,
            'side-menu__item--inactive': item.inactive
          }"
        >
          <div
            ref="menuItem"
            class="side-menu__inner center-horizontal"
          >
            <router-link
              :class="{
                'center-horizontal': true,
                'side-menu__link': true,
                'side-menu__link--active': activeMenuOptions.includes(item.name),
                'side-menu__inactive': item.inactive
              }"
              :to="item.url"
            >
              <component
                :is="item.image"
                class="side-menu__item-img"
              />
              <span class="side-menu__item-name-wrapper">
                <span
                  :class="{
                    'side-menu__item-name': true,
                    'side-menu__item-name--inactive': item.inactive
                }">
                  {{ item.displayName }}
                </span>
              </span>
            </router-link>
            <div
              v-if="item.subItems && item.subItems.length > 0"
              class="side-menu__arrow-wrapper"
              @click="toggleMenu(item, $event.target)"
            >
              <ds-arrow-icon
                :open="activeMenuOptions.includes(item.name)"
                fill="#8390a5"
              />
            </div>
            <div
              v-if="sideArrowOnActive && activeMenuOptions.includes(item.name)"
              class="side-menu__active-position"
            >
              <ds-arrow-icon
                :open="activeMenuOptions.includes(item.name)"
                :default-rotation="0"
                fill="#43cea2"
              />
            </div>
          </div>
          <ul v-if="activeMenuOptions.includes(item.name)">
            <li
              v-for="interMenuItem in item.interMenu"
              :key="interMenuItem.displayName"
            >
              <div
                class="center-horizontal inter-menu-item-wrapper"
                @click="toggleInterMenu(item, $event.target)"
              >
                <router-link :to="interMenuItem.url">
                  <div class="center-horizontal inter-menu-inner">
                    <span>{{ interMenuItem.displayName }}</span>
                    <ds-arrow-icon
                      :open="$route.params.host === interMenuItem.displayName"
                      fill="#8390a5"
                    />
                  </div>
                </router-link>
                <ul
                  v-if="interMenuItem.subItems.length > 0"
                  ref="menuList"
                  :data-url="interMenuItem.displayName"
                  :class="{
                    'side-menu__subitem-list': true,
                    'side-menu__subitem-list--active': $route.params.host === interMenuItem.displayName,
                    'side-menu__subitem-list--inactive': !$route.params.host === interMenuItem.displayName
                  }"
                >
                  <li
                    v-for="(subItem, index) in interMenuItem.subItems"
                    :key="`${interMenuItem.name}${index}`"
                    class="center-horizontal"
                  >
                    <router-link
                      :to="subItem.url"
                      class="side-menu__sublink"
                    >
                      <ds-submenu-icon />
                      <span class="side-menu__sublink-name">
                        {{ subItem.name }}
                      </span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <ul
            v-if="item.subItems"
            ref="menuList"
            :data-url="item.name"
            :class="{
              'side-menu__subitem-list': true,
              'side-menu__subitem-list--active': activeMenuOptions.includes(item.name),
              'side-menu__subitem-list--inactive': !activeMenuOptions.includes(item.name)
            }"
          >
            <li
              v-for="(subItem, index) in item.subItems"
              :key="`${item.name}${index}`"
              class="center-horizontal"
            >
              <router-link
                :to="subItem.url"
                class="side-menu__sublink"
              >
                <ds-submenu-icon />
                <span class="side-menu__sublink-name">
                  {{ subItem.name }}
                </span>
              </router-link>
            </li>
            <div
              v-if="item.subItemsTotal > item.subItems.length"
              class="side-menu__load-more"
              @click="item.loadMoreSubItems"
            >
              <ds-dots-icon />
              <span>{{ loadMoreText }}</span>
            </div>
          </ul>
        </li>
      </ul>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
// TODO this menu should be a recursive component...
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DsArrowIcon from "../icons/ds-arrow-icon";
import DsDotsIcon from "../icons/ds-dots-icon";
import DsSubmenuIcon from "../icons/ds-submenu-icon";

function whichTransitionEvent() {
  var t;
  var el = document.createElement("fakeelement");
  var transitions = {
    transition: "transitionend",
    OTransition: "oTransitionEnd",
    MozTransition: "transitionend",
    WebkitTransition: "webkitTransitionEnd"
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

export default {
  name: "DsCollapseMenu",
  components: {
    VuePerfectScrollbar,
    DsArrowIcon,
    DsSubmenuIcon,
    DsDotsIcon
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    subItemsTotal: {
      type: Number,
      default: 0
    },
    subItemsPeerPage: {
      type: Number,
      default: 0
    },
    sideArrowOnActive: {
      type: Boolean,
      default: false
    },
    loadMoreText: {
      type: String,
      default: "load more"
    }
  },
  data() {
    return {
      activeMenuOptions:
        Object.keys(this.$route.meta).length > 0 ? [this.$route.meta] : [],
      activeInterMenuOptions: [],
      isMounted: false,
      settings: {
        maxScrollbarLength: 50
      }
    };
  },
  computed: {
    menuItems() {
      return this.items.map((item, key) => Object.assign(item, { key }));
    }
  },
  watch: {
    $route() {
      this.activeMenuOptions =
        Object.keys(this.$route.meta).length > 0 ? [this.$route.meta] : [];
      this.renderMenu();
    }
  },
  mounted() {
    if (this.$refs.menuList) {
      this.$refs.menuList.forEach(el => {
        el.addEventListener(whichTransitionEvent, () => {
          this.$refs.perfectScollbar.update();
        });
      });
      this.renderMenu();
    }
  },
  methods: {
    renderMenu() {
      if (this.$refs.menuList) {
        this.$refs.menuList.forEach(el => {
          el.style.height = this.activeMenuOptions.includes(
            el.getAttribute("data-url")
          )
            ? `${el.scrollHeight}px`
            : "0px";
        });
      }

      setTimeout(() => {
        this.isMounted = true;
      }, 300);
    },
    toggleMenu(item) {
      if (this.activeMenuOptions.includes(item.name)) {
        this.activeMenuOptions = this.activeMenuOptions.filter(
          e => e !== item.name
        );
      } else {
        this.activeMenuOptions.push(item.name);
      }
      this.renderMenu();
    },
    toggleInterMenu(item) {}
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";

.scroll-area {
  position: relative;
  margin: auto;
  width: 250px;
  height: 100%;
}
.side-menu {
  height: 100%;
  padding: 18px 18px 16px 17px;
  font-size: $font-regular-size !important;
  &__inactive {
    pointer-events: none;
    cursor: default;
  }
  &__list {
    height: 100%;
  }
  &__item {
    cursor: pointer;
    margin-bottom: 20px;
    user-select: none;
    &--inactive {
      cursor: default;
      opacity: 0.6;
    }
  }
  &__inner {
    position: relative;
  }
  &__item-img {
    width: 20px;
    // height: 20px;
    margin-right: 10px;
    svg {
      height: 100% !important;
    }
  }
  &__item-name-wrapper {
    position: relative;
  }
  &__item-name {
    // position: absolute;
    top: 50%;
    transform: translateY(-45%);
    &--inactive {
      color: gray !important;
    }
  }
  &__arrow-wrapper {
    svg {
      margin-left: 14px;
      margin-bottom: 2px;
    }
  }
  &__arrow {
    transform: rotate(180deg);
    transition: $transition-duration;
    &--open {
      transition: $transition-duration;
      transform: rotate(0deg);
    }
  }
  &__link,
  &__sublink {
    &:focus,
    &:active {
      outline: none;
    }
  }
  &__link {
    line-height: 24px;
    color: #fff;
    font-weight: 600;
    width: 100%;
    transition: 0.1;
    &:hover {
      transition: 0.1;
      color: $light-gray-color;
    }
    &--active {
      color: #f7f7f7;
    }
  }
  &__sublink {
    width: 100%;
    color: #fff;
    font-size: $font-small-size !important;
    display: flex;
    align-items: flex-end;
    transition: 0.1;
    span:first-child {
      margin-bottom: 4px;
    }
    &:hover {
      transition: 0.1;
      color: $light-gray-color;
    }
  }
  &__sublink-name {
    align-self: flex-end;
    margin-left: 5px;
  }
  &__subitem-list {
    transform-origin: top;
    overflow-y: hidden;
    height: 0px;
    &--inactive {
      transform: scale(1, 0);
      // transition: $transition-duration;
    }
    &--active {
      height: initial !important;
      transform: scale(1, 1);
      // transition: $transition-duration;
    }
  }
  &--inactive {
    .side-menu__subitem-list {
      -webkit-transition: none !important;
      -moz-transition: none !important;
      -o-transition: none !important;
      transition: none !important;
    }
  }
  &__subitem-text {
    font-size: $font-small-size;
    margin-left: 8px;
  }
  &__load-more {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: rgba(141, 153, 174, 0.1);
    margin: 15px;
    border-radius: 5px;
    color: #fff;
    margin: 10px auto;
    margin-bottom: 0px;
    padding: 0px 3px;
    transition: 0.05s;
    &:hover {
      background-color: rgba(141, 153, 174, 0.2);
    }
    > span:first-child {
      margin-right: 10px;
    }
    font-size: $font-small-size;
  }
  .ps-scrollbar-x-rail > .ps-scrollbar-x {
    transition: 0.2s linear left;
  }
  .ps-scrollbar-y-rail > .ps-scrollbar-y {
    transition: 0.2s linear top;
  }
}

.inter-menu-item-wrapper {
  margin-left: 1.75em;
  margin-top: 1em;
  font-weight: 600;
  display: block;
  a {
    color: #fff !important;
  }
}
.inter-menu-inner {
  word-wrap: break-word;
  > span {
    max-width: 180px;
  }
  .icon-wrapper {
    margin-left: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-collapse.menu.vue